import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import './buttonsStyles.scss';

const TrailerButton = ({ isVisible, onClick }) => {
  const asset = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);

  if (!isVisible) return null;
  return (
    <Button
      buttonType="outlined"
      id="show_trailer"
      onClick={() => onClick('trailer')}
    >
      <div className="ActionButton__content">
        <div className="ActionButton__content__image">
          <img src={asset.vcard_access_option_icon_trailer} alt="play" />
        </div>
        <p className="ActionButton__content__text">
          {translations.vcard_access_option_button_trailer}
        </p>
      </div>
    </Button>
  );
};

TrailerButton.propTypes = {
  isVisible: PropTypes.bool,
  onClick: PropTypes.func,
};

TrailerButton.defaultProps = {
  isVisible: false,
  onClick: () => 1,
};

export default TrailerButton;
